import { GtmhubController } from "@gtmhub/core";
import { IGridCustomField } from "@gtmhub/customFields";
import { checkOverflowOfColumnWidth } from "@gtmhub/shared/utils/tooltips-util";
import { IComponentOptions } from "angular";
import { IGHCellChangePayload, IGHGridColumn } from "../../../shared/components/grid/grid.component";

export interface ICFCellComponentBindings {
  onChange(payload: IGHCellChangePayload<Partial<IGridCustomField>>): void;
  item: IGridCustomField;
  column: IGHGridColumn;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CFCellCtrl extends ICFCellComponentBindings {}

export class CFCellCtrl extends GtmhubController {
  changeCell = (item: Partial<IGridCustomField>, action: string): void => {
    if (this.onChange) {
      this.onChange({ item, action });
    }
  };

  shouldEnableTooltip(item: IGridCustomField): boolean {
    return item.operationalType === "session" ? this.isOverflowReached(this.setElementIdFromSessionNames(item)) : false;
  }

  setElementIdFromSessionNames(item: IGridCustomField): string {
    const result: string[] = [];
    item.sessions.forEach((session) => result.push(session.name));
    return result.toString();
  }

  isOverflowReached(id: string): boolean {
    return id ? checkOverflowOfColumnWidth(id, this.column.fieldName) : false;
  }

  isCustomFieldInSessionSpecificContext(item: IGridCustomField): boolean {
    return item.targetTypes == "goal" || item.targetTypes == "metric" || item.targetTypes == "metric_snapshot";
  }
}

export const CustomFieldsCellComponent: IComponentOptions = {
  bindings: {
    item: "<",
    column: "<",
    onChange: "&",
  },
  controller: CFCellCtrl,
  templateUrl: require("./cf-cell.component.jade"),
};
